/**
 * Maps axios/API errors to a user-visible string (SRP: error presentation only).
 */
export function getApiErrorMessage(error, fallback = 'Request failed') {
  if (!error) return fallback;
  const fromBody = error.response?.data?.message || error.response?.data?.error?.message;
  if (typeof fromBody === 'string' && fromBody.trim()) return fromBody;
  if (error.message) return error.message;
  return fallback;
}
